import React, { useMemo } from 'react'

import { Box, Loader } from '@tidbcloud/uikit'

import {
  FilterMultiSelect as ClinicFilterMultiSelect,
  FilterMultiSelectProps as ClinicFilterMultiSelectProps
} from '../SQLRepository/List/FilterMultiSelect'

interface FilterMultiSelectProps
  extends Omit<ClinicFilterMultiSelectProps, 'data' | 'onChange'> {
  data: ClinicFilterMultiSelectProps['data']
  onChange: (value: string[]) => void
  loading?: boolean
  onDropdownOpen?: () => void
  getValueLabel?: (value: string) => string
  singleSelect?: boolean
}

/** Adds the V2-only capabilities without changing SQL Repository behavior. */
export function FilterMultiSelect({
  data,
  value,
  onChange,
  loading,
  onDropdownOpen,
  getValueLabel,
  singleSelect,
  ...props
}: FilterMultiSelectProps) {
  const displayData = useMemo(() => {
    const normalized = data.map((item) => ({
      ...item,
      label: getValueLabel ? getValueLabel(item.value) : item.label
    }))
    value.forEach((selected) => {
      if (!normalized.some((item) => item.value === selected)) {
        normalized.push({
          value: selected,
          label: getValueLabel ? getValueLabel(selected) : selected
        })
      }
    })
    return normalized
  }, [data, getValueLabel, value])

  return (
    <Box pos='relative' onClickCapture={onDropdownOpen}>
      <ClinicFilterMultiSelect
        {...props}
        value={value}
        data={displayData}
        onChange={(next) => {
          if (!singleSelect || next.length <= 1) {
            onChange(next)
            return
          }
          onChange([next[next.length - 1]])
        }}
      />
      {loading && (
        <Loader
          size={14}
          pos='absolute'
          top='50%'
          right={34}
          style={{ transform: 'translateY(-50%)' }}
        />
      )}
    </Box>
  )
}
